import { useNavigate } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal } from "@/components/motion/Reveal";

export default function CTASection({ eyebrow, title, body, btn, to = "/contact" }) {
  const navigate = useNavigate();
  return (
    <section data-testid="cta-section" className="relative py-28 lg:py-36 overflow-hidden">
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          background:
            "radial-gradient(600px circle at 50% 40%, rgba(0,229,255,0.10), transparent 70%)",
        }}
      />
      <div className="relative max-w-[1320px] mx-auto px-6 lg:px-10">
        <div className="border border-white/10 bg-navy-surface/60 backdrop-blur-sm p-10 lg:p-20 text-center">
          {eyebrow && (
            <Reveal>
              <span className="font-mono-tech text-[12px] uppercase tracking-widest text-cyan-precision">
                {eyebrow}
              </span>
            </Reveal>
          )}
          <Reveal delay={0.08}>
            <h2 className="mt-5 font-display font-light tracking-tight text-3xl sm:text-4xl lg:text-6xl leading-[1.05] text-[#F0F4F8] max-w-4xl mx-auto">
              {title}
            </h2>
          </Reveal>
          <Reveal delay={0.16}>
            <p className="mt-6 text-lg text-[#94A3B8] max-w-2xl mx-auto leading-relaxed">{body}</p>
          </Reveal>
          <Reveal delay={0.24}>
            <button
              data-testid="cta-button"
              onClick={() => navigate(to)}
              className="mt-10 inline-flex items-center gap-2 font-mono-tech text-[13px] uppercase tracking-widest border border-cyan-precision text-cyan-precision px-8 py-4 hover:bg-cyan-precision hover:text-navy transition-colors cyan-glow"
            >
              {btn} <ArrowUpRight size={16} />
            </button>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
